/**
 * How often the widget tells the server it is still alive while live on a campaign.
 *
 * Must stay comfortably under the server's own missed-heartbeat threshold (currently 3 missed
 * beats at this interval - see ringba-x's `SoftphoneHeartbeatPolicy`), or a single slow tick would
 * risk tripping the auto-pause on a widget that is actually fine. The two are configured
 * independently rather than shared, because they live in different repos and different
 * deployments; a change to one is not automatically safe to make without checking the other.
 */
export const HEARTBEAT_POLICY_DEFAULTS = Object.freeze({
  intervalInMs: 15 * 1000
})

let policy = { ...HEARTBEAT_POLICY_DEFAULTS }

export function getHeartbeatPolicy() {
  return policy
}

/**
 * Test and e2e seam, same reasoning as `configureReconnectPolicy`: a test that had to wait out the
 * real interval to see a heartbeat fire would slow the suite for no benefit. Reached only through
 * the softphone dev hook, stripped from production builds.
 */
export function configureHeartbeatPolicy(overrides = {}) {
  policy = { ...policy, ...overrides }

  return policy
}

export function resetHeartbeatPolicy() {
  policy = { ...HEARTBEAT_POLICY_DEFAULTS }

  return policy
}
